import { ACCEPTED_FILE_FORMATS, INVALID_FILE_MESSAGES } from './constants';

export const acceptedFileFormats = ACCEPTED_FILE_FORMATS.join(',');

export const isValidType = (file) => ACCEPTED_FILE_FORMATS.includes(file.type);

export const convertBytesToKB = (bytes) => (bytes / 1024).toFixed(2);

export const validateFile = (file) => {
  if (!isValidType(file)) {
    return INVALID_FILE_MESSAGES.TYPE;
  }
};
